import {CardHole, HoleType} from "./CardBacks";

declare let Konva: any;

export class Formatter {
  canvasWidth: number = 100;
  canvasHeight: number = 100;
  isMobile: boolean = false;

  constructor() {
  }

  setUpHoleForResizing(stage: any, layer: any, h: CardHole, clear: () => void, update: () => void,
                       tap: (e: any) => void = (e: any) => {}) {
    console.log("Set up hole for resizing");
    this.createHoleGroup(stage, layer, h, clear, update, tap);
    switch(h.type) {
      case HoleType.square:
        this.createSquareAnchors(h, clear, update);
        break;
      case HoleType.circle:
        this.createCircleAnchors(h, clear, update);
        break;
      case HoleType.triangle:
        this.createTriangleAnchors(h, clear, update);
        break;
      case HoleType.diamond:
        this.createDiamondAnchors(h, clear, update);
        break;
      case HoleType.star:
        this.createStarAnchors(h, clear, update);
        break;
      case HoleType.club:
        this.createClubAnchors(h, clear, update);
        break;
      case HoleType.heart:
        this.createHeartAnchors(h, clear, update);
        break;
      case HoleType.spade:
        this.createSpadeAnchors(h, clear, update);
        break;
      default: //This should never happen
        return;
    }
    layer.draw();
  }

  createSquareAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos, 'topLeft', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos, 'topRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + h.hPos, 'bottomRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + h.hPos, 'bottomLeft', h, clear, update);
  }

  createCircleAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + (h.wPos / 2), h.yPos, 'top', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + (h.hPos / 2), 'left', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + (h.hPos / 2), 'right', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + (h.wPos / 2), h.yPos + h.hPos, 'bottom', h, clear, update);
  }

  createDiamondAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + (h.wPos / 2), h.yPos, 'top', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + (h.hPos / 2), 'left', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + (h.hPos / 2), 'right', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + (h.wPos / 2), h.yPos + h.hPos, 'bottom', h, clear, update);
  }

  createTriangleAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + (h.wPos / 2), h.yPos, 'top', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + h.hPos, 'bottomLeft', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + h.hPos, 'bottomRight', h, clear, update);
  }

  createStarAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos, 'topLeft', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos, 'topRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + h.hPos, 'bottomRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + h.hPos, 'bottomLeft', h, clear, update);
  }

  createHeartAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos, 'topLeft', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos, 'topRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + h.hPos, 'bottomRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + h.hPos, 'bottomLeft', h, clear, update);
  }

  createSpadeAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos, 'topLeft', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos, 'topRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + h.hPos, 'bottomRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + h.hPos, 'bottomLeft', h, clear, update);
  }

  createClubAnchors(h: CardHole, clear: () => void, update: () => void) {
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos, 'topLeft', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos, 'topRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos + h.wPos, h.yPos + h.hPos, 'bottomRight', h, clear, update);
    this.createHoleAnchor(h.anchorGroupSave, h.xPos, h.yPos + h.hPos, 'bottomLeft', h, clear, update);
  }

  createHoleGroup(stage, layer, h: CardHole, clear: () => void, update: () => void, tap: (e: any) => void) {
    var group = null;
    if (h.hasKonvaGroup) {
      group = h.konvaGroup;
      h.konvaGroup.setAttrs({
        x: 0,
        y: 0,
        draggable: false
      });
      group.removeChildren();
    } else {
      group = new Konva.Group({
        x: 0,
        y: 0,
        draggable: false
      });
      h.konvaGroup = group;
      h.hasKonvaGroup = true;
    }
    layer.add(group);
    var rect = null;
    if (h.hasRectGroup) {
      rect = h.rectGroupSave;
      h.rectGroupSave.setAttrs({
        x: 0,
        y: 0,
        width: h.wPos,
        height: h.hPos
      });
    } else {
      rect = new Konva.Rect({
        x: h.xPos,
        y: h.yPos,
        width: h.wPos,
        height: h.hPos,
        fill: '#ffffff00',
        stroke: '#ffffff00',
        strokeWidth: 0
      });
      h.rectGroupSave = rect;
      h.hasRectGroup = true;
    }
    group.add(rect);
    group.off("touchend");
    group.on("touchend", (e) => {
      console.log("Hole group touch: ", e);
      tap(e);
    });
    var anchorGroup = null;
    if (h.hasAnchorGroup) {
      anchorGroup = h.anchorGroupSave;
      h.anchorGroupSave.setAttrs({
        x: 0,
        y: 0,
        draggable: true
      });
      anchorGroup.removeChildren();
    } else {
      anchorGroup = new Konva.Group({
        x: 0,
        y: 0,
        draggable: true
      });
      h.anchorGroupSave = anchorGroup;
      h.hasAnchorGroup = true;
    }
    layer.add(anchorGroup);
  }

  updateAnchorGroup(rectGroup, anchorGroup) {
    anchorGroup.setX(rectGroup.getX());
    anchorGroup.setY(rectGroup.getY());
  }

  handleGroupDrag(group, rect, h: CardHole) {
    switch(h.type) {
      case HoleType.square:
        this.updateSquareGroup(h);
        break;
      case HoleType.circle:
        this.updateCircleGroup(h);
        break;
      case HoleType.diamond:
        this.updateDiamondGroup(h);
        break;
      case HoleType.triangle:
        this.updateTriangleGroup(h);
        break;
      case HoleType.star:
        this.updateStarGroup(h);
        break;
      default: //This should never happen
        break;
    }

  }

  updateSquareGroup(h: CardHole) {
    let topLeft = h.anchorGroupSave.get('.topLeft')[0];
    h.xPos = topLeft.getX() + h.anchorGroupSave.getX();
    h.yPos = topLeft.getY() + h.anchorGroupSave.getY();
  }

  updateCircleGroup(h: CardHole) {
    let left = h.anchorGroupSave.get('.left')[0];
    let top = h.anchorGroupSave.get('.top')[0];
    h.xPos = left.getX() + h.anchorGroupSave.getX();
    h.yPos = top.getY() + h.anchorGroupSave.getY();
  }

  updateDiamondGroup(h: CardHole) {
    let left = h.anchorGroupSave.get('.left')[0];
    let top = h.anchorGroupSave.get('.top')[0];
    h.xPos = left.getX() + h.anchorGroupSave.getX();
    h.yPos = top.getY() + h.anchorGroupSave.getY();
  }

  updateTriangleGroup(h: CardHole) {
    let left = h.anchorGroupSave.get('.bottomLeft')[0];
    let top = h.anchorGroupSave.get('.top')[0];
    h.xPos = left.getX() + h.anchorGroupSave.getX();
    h.yPos = top.getY() + h.anchorGroupSave.getY();
  }

  updateStarGroup(h: CardHole) {

  }

  makeNewAnchor(group, x, y, name, h, clear, update) {
    let anchor = new Konva.Circle({
      x: x,
      y: y,
      stroke: '#000000',
      fill: '#ffffff',
      strokeWidth: 2,
      radius: this.isMobile ? 16 : 8,
      name: name,
      draggable: true,
      dragOnTop: false
    });

    anchor.on('dragmove', () => {
      // console.log("Hole anchor Drag move");
      this.updateCoAnchors(anchor, h);
      this.updateHolePos(anchor, h);
      clear();
    });
    anchor.on('mousedown touchstart', () => {
      // console.log("Hole anchor Mouse down");
      // group.setDraggable(false);
      this.mouseDown(anchor, group);
    });
    anchor.on('dragend', () => {
      // console.log("Hole anchor Drag end");
      this.updateHolePos(anchor, h);
      // group.setDraggable(true);
      update();
    });
    // add hover styling
    anchor.on('mouseover', function() {
      // console.log("Hole anchor Mouse over");
      console.log("Group Draggable? ", group.getDraggable());
      let layer = this.getLayer();
      document.body.style.cursor = 'pointer';
      this.setStrokeWidth(4);
      layer.draw();
    });
    anchor.on('mouseout', function() {
      // console.log("Hole anchor Mouse out");
      group.setDraggable(false);
      let layer = this.getLayer();
      document.body.style.cursor = 'default';
      this.setStrokeWidth(2);
      layer.draw();
    });
    return anchor;
  }

  createHoleAnchor(group, x, y, name, h: CardHole, clear: () => void, update: () => void) {
    let stage = group.getStage();
    let layer = group.getLayer();
    console.log("At make hole anchor");
    var anchor = null;
    console.log("Has anchor: ", h['has' + name])
    if (h['has' + name] === true) {
      anchor = h['save' + name];
      anchor.setAttrs({
        x: x,
        y: y,
        draggable: true
      });
      anchor.draggable(true);
    } else {
      anchor = this.makeNewAnchor(group, x, y, name, h, clear, update);
      h['save' + name] = anchor;
      h['has' + name] = true;
    }
    console.log("Here at adding anchor", group);
    group.add(anchor);
    console.log("After adding anchor to group");
  }

  updateHolePos(anchor: any, h: CardHole) {
    switch(h.type) {
      case HoleType.square:
        this.updateSquareHolePos(anchor, h);
        break;
      case HoleType.circle:
        this.updateCircleHolePos(anchor, h);
        break;
      case HoleType.diamond:
        this.updateDiamondHolePos(anchor, h);
        break;
      case HoleType.triangle:
        this.updateTriangleHolePos(anchor, h);
        break;
      case HoleType.star:
        this.updateSquareHolePos(anchor, h);
        break;
      case HoleType.heart:
        this.updateSquareHolePos(anchor, h);
        break;
      case HoleType.spade:
        this.updateSquareHolePos(anchor, h);
        break;
      case HoleType.club:
        this.updateSquareHolePos(anchor, h);
        break;
      default: //This should never happen
        break;
    }
  }

  recenterHole(anchor, h: CardHole) {
    console.log("Recenter hole");
    var x = (this.canvasWidth - h.wPos) / 2;
    var y = (this.canvasHeight - h.hPos) / 2;
    h.xPos = x;
    h.yPos = y;
    this.resetAllAnchors(anchor, h);
  }

  updateSquareHolePos(anchor: any, h: CardHole) {
    let group = anchor.getParent();

    let topLeft = group.get('.topLeft')[0];
    let topRight = group.get('.topRight')[0];
    let bottomRight = group.get('.bottomRight')[0];
    let bottomLeft = group.get('.bottomLeft')[0];

    h.xPos = topLeft.getX() + h.anchorGroupSave.getX();
    h.yPos = topLeft.getY() + h.anchorGroupSave.getY();
    h.wPos = topRight.getX() - h.xPos + h.anchorGroupSave.getX();
    h.hPos = bottomRight.getY() - h.yPos + h.anchorGroupSave.getY();
    this.recenterHole(anchor, h);

    console.log("Update hole pos: ", h);
  }

  updateCircleHolePos(anchor: any, h: CardHole) {
    let group = anchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.left')[0];
    let right = group.get('.right')[0];
    let bottom = group.get('.bottom')[0];

    h.xPos = left.getX() + h.anchorGroupSave.getX();
    h.yPos = top.getY() + h.anchorGroupSave.getY();
    h.wPos = right.getX() - h.xPos + h.anchorGroupSave.getX();
    h.hPos = bottom.getY() - h.yPos + h.anchorGroupSave.getY();
    this.recenterHole(anchor, h);

    console.log("Update hole pos: ", h);
  }

  updateDiamondHolePos(anchor: any, h: CardHole) {
    let group = anchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.left')[0];
    let right = group.get('.right')[0];
    let bottom = group.get('.bottom')[0];

    h.xPos = left.getX() + h.anchorGroupSave.getX();
    h.yPos = top.getY() + h.anchorGroupSave.getY();
    h.wPos = right.getX() - h.xPos + h.anchorGroupSave.getX();
    h.hPos = bottom.getY() - h.yPos + h.anchorGroupSave.getY();
    this.recenterHole(anchor, h);

    console.log("Update hole pos: ", h);
  }

  updateTriangleHolePos(anchor: any, h: CardHole) {
    let group = anchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.bottomLeft')[0];
    let right = group.get('.bottomRight')[0];

    h.xPos = left.getX() + h.anchorGroupSave.getX();
    h.yPos = top.getY() + h.anchorGroupSave.getY();
    h.wPos = right.getX() - h.xPos + h.anchorGroupSave.getX();
    h.hPos = right.getY() - h.yPos + h.anchorGroupSave.getY();
    this.recenterHole(anchor, h);

    console.log("Update hole pos: ", h);
  }

  updateStarHolePos(anchor: any, h: CardHole) {

  }

  resetAllAnchors(activeAnchor, h: CardHole) {
    console.log("Reset anchors");
    switch(h.type) {
      case HoleType.square:
        setTimeout(() => {
          this.resetSquareAnchors(activeAnchor, h);
        }, 100);
        break;
      case HoleType.circle:
        setTimeout(() => {
          this.resetCircleAnchors(activeAnchor, h);
        }, 100);
        break;
      case HoleType.heart:
        setTimeout(() => {
          this.resetSquareAnchors(activeAnchor, h);
        }, 100);
        break;
      case HoleType.spade:
        setTimeout(() => {
          this.resetSquareAnchors(activeAnchor, h);
        }, 100);
        break;
      case HoleType.club:
        setTimeout(() => {
          this.resetSquareAnchors(activeAnchor, h);
        }, 100);
        break;
      case HoleType.star:
        setTimeout(() => {
          this.resetSquareAnchors(activeAnchor, h);
        }, 100);
        break;
      default:
        break;
    }
  }

  updateCoAnchors(activeAnchor, h: CardHole) {
    switch(h.type) {
      case HoleType.square:
        this.updateSquareAnchors(activeAnchor);
        break;
      case HoleType.circle:
        this.updateCircleAnchors(activeAnchor);
        break;
      case HoleType.diamond:
        this.updateDiamondAnchors(activeAnchor);
        break;
      case HoleType.triangle:
        this.updateTriangleAnchors(activeAnchor);
        break;
      case HoleType.star:
        this.updateSquareAnchors(activeAnchor);
        break;
      case HoleType.heart:
        this.updateSquareAnchors(activeAnchor);
        break;
      case HoleType.spade:
        this.updateSquareAnchors(activeAnchor);
        break;
      case HoleType.club:
        this.updateSquareAnchors(activeAnchor);
        break;
      default: //This should never happen
        break;
    }
  }

  resetSquareAnchors(activeAnchor, h: CardHole) {
    let group = activeAnchor.getParent();

    let topLeft = group.get('.topLeft')[0];
    let topRight = group.get('.topRight')[0];
    let bottomRight = group.get('.bottomRight')[0];
    let bottomLeft = group.get('.bottomLeft')[0];

    topLeft.setX(h.xPos);
    topLeft.setY(h.yPos);
    topRight.setX(h.xPos + h.wPos);
    topRight.setY(h.yPos);
    bottomRight.setX(h.xPos + h.wPos);
    bottomRight.setY(h.yPos + h.hPos);
    bottomLeft.setX(h.xPos);
    bottomLeft.setY(h.yPos + h.hPos);

    var x = h.anchorGroupSave.getX();
    var y = h.anchorGroupSave.getY();
    console.log("Group x: ", x, "Group y: ", y);

    activeAnchor.getLayer().draw();

  }

  resetCircleAnchors(activeAnchor, h: CardHole) {
    let group = activeAnchor.getParent();

    let top = group.get('.top')[0];
    let right = group.get('.right')[0];
    let left = group.get('.left')[0];
    let bottom = group.get('.bottom')[0];

    top.setX(h.xPos + (h.wPos / 2));
    top.setY(h.yPos);
    right.setX(h.xPos + h.wPos);
    right.setY(h.yPos + (h.hPos / 2));
    left.setX(h.xPos);
    left.setY(h.yPos + (h.hPos / 2));
    bottom.setX(h.xPos + (h.wPos / 2));
    bottom.setY(h.yPos + h.hPos);

    activeAnchor.getLayer().draw();
  }

  updateSquareAnchors(activeAnchor) {
    console.log("Updating square anchors");
    let group = activeAnchor.getParent();

    let topLeft = group.get('.topLeft')[0];
    let topRight = group.get('.topRight')[0];
    let bottomRight = group.get('.bottomRight')[0];
    let bottomLeft = group.get('.bottomLeft')[0];
    let image = group.get('Image')[0];

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'topLeft':
        topRight.setY(anchorY);
        bottomLeft.setX(anchorX);
        break;
      case 'topRight':
        topLeft.setY(anchorY);
        bottomRight.setX(anchorX);
        break;
      case 'bottomRight':
        bottomLeft.setY(anchorY);
        topRight.setX(anchorX);
        break;
      case 'bottomLeft':
        bottomRight.setY(anchorY);
        topLeft.setX(anchorX);
        break;
    }
  }

  updateCircleAnchors(activeAnchor) {
    let group = activeAnchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.left')[0];
    let right = group.get('.right')[0];
    let bottom = group.get('.bottom')[0];
    let image = group.get('Image')[0];

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'top':
        var h1 = bottom.getY() - anchorY;
        left.setY(anchorY + (h1 / 2));
        right.setY(anchorY + (h1 / 2));
        top.setX(bottom.getX());
        break;
      case 'left':
        var w1 = right.getX() - anchorX;
        top.setX(anchorX + (w1 / 2));
        bottom.setX(anchorX + (w1 / 2));
        left.setY(right.getY());
        break;
      case 'right':
        var w2 = anchorX - left.getX();
        bottom.setX(left.getX() + (w2 / 2));
        top.setX(left.getX() + (w2 / 2));
        right.setY(left.getY());
        break;
      case 'bottom':
        var h2 = anchorY - top.getY();
        right.setY(top.getY() + (h2 / 2));
        left.setY(top.getY() + (h2 / 2));
        bottom.setX(top.getX());
        break;
    }
  }

  updateDiamondAnchors(activeAnchor) {
    let group = activeAnchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.left')[0];
    let right = group.get('.right')[0];
    let bottom = group.get('.bottom')[0];
    let image = group.get('Image')[0];

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'top':
        var h1 = bottom.getY() - anchorY;
        left.setY(anchorY + (h1 / 2));
        right.setY(anchorY + (h1 / 2));
        top.setX(bottom.getX());
        break;
      case 'left':
        var w1 = right.getX() - anchorX;
        top.setX(anchorX + (w1 / 2));
        bottom.setX(anchorX + (w1 / 2));
        left.setY(right.getY());
        break;
      case 'right':
        var w2 = anchorX - left.getX();
        bottom.setX(left.getX() + (w2 / 2));
        top.setX(left.getX() + (w2 / 2));
        right.setY(left.getY());
        break;
      case 'bottom':
        var h2 = anchorY - top.getY();
        right.setY(top.getY() + (h2 / 2));
        left.setY(top.getY() + (h2 / 2));
        bottom.setX(top.getX());
        break;
    }
  }

  updateTriangleAnchors(activeAnchor) {
    let group = activeAnchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.bottomLeft')[0];
    let right = group.get('.bottomRight')[0];
    let image = group.get('Image')[0];

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'top':
        var h1 = right.getY() - anchorY;
        top.setX(left.getX() + ((right.getX() - left.getX()) / 2));
        break;
      case 'bottomLeft':
        var w1 = right.getX() - anchorX;
        top.setX(anchorX + (w1 / 2));
        left.setY(right.getY());
        break;
      case 'bottomRight':
        var w2 = anchorX - left.getX();
        top.setX(left.getX() + (w2 / 2));
        right.setY(left.getY());
        break;
    }
  }

  updateStarAnchors(activeAnchor) {
    let group = activeAnchor.getParent();

    let top = group.get('.top')[0];
    let left = group.get('.left')[0];
    let right = group.get('.right')[0];
    let bottom = group.get('.bottom')[0];
    let image = group.get('Image')[0];

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'top':
        var h1 = bottom.getY() - anchorY;
        left.setY(anchorY + (h1 / 2));
        right.setY(anchorY + (h1 / 2));
        top.setX(bottom.getX());
        break;
      case 'left':
        var w1 = right.getX() - anchorX;
        top.setX(anchorX + (w1 / 2));
        bottom.setX(anchorX + (w1 / 2));
        left.setY(right.getY());
        break;
      case 'right':
        var w2 = anchorX - left.getX();
        bottom.setX(anchorX + (w2 / 2));
        top.setX(anchorX + (w2 / 2));
        right.setY(left.getY());
        break;
      case 'bottom':
        var h2 = anchorY - top.getY();
        right.setY(anchorY + (h2 / 2));
        left.setY(anchorY + (h2 / 2));
        bottom.setX(top.getX());
        break;
    }
  }

  mouseDown = (anchor, group) => {
    // console.log("Mouse down");
    group.setDraggable(false);
    anchor.moveToTop();
  };
}
